export { default } from './ApplePayNew';
